$(function () {
  $('.acc-trigger').on('click', function () {
    $(this).toggleClass('is-active');
    $(this).next('.acc-target').slideToggle(300);
  });
});
